import { render, staticRenderFns } from "./preferentialManagement.vue?vue&type=template&id=0263da4e&scoped=true&"
import script from "./preferentialManagement.vue?vue&type=script&lang=js&"
export * from "./preferentialManagement.vue?vue&type=script&lang=js&"
import style0 from "./preferentialManagement.vue?vue&type=style&index=0&id=0263da4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0263da4e",
  null
  
)

export default component.exports